import { Layout } from '@/views/exchange';

export default {
    path: '/exchange',
    component: Layout,
    children: [
        { path: 'add', component: () => import('@/views/exchange/AddExchange.vue') },
    ]
};
